/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilitySettingsSettings
 */
export interface FacilitySettingsSettings {
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    insurance_eligibility_check: FacilitySettingsSettingsInsuranceEligibilityCheckEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    pdpm_estimator: FacilitySettingsSettingsPdpmEstimatorEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    pal_preauth?: FacilitySettingsSettingsPalPreauthEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    pal_hospital_initiated?: FacilitySettingsSettingsPalHospitalInitiatedEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    tim_report?: FacilitySettingsSettingsTimReportEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    phone_agent?: FacilitySettingsSettingsPhoneAgentEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    waitlist_enabled?: FacilitySettingsSettingsWaitlistEnabledEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    automatically_add_to_waitlist?: FacilitySettingsSettingsAutomaticallyAddToWaitlistEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    rule_and_data_pull_categories?: FacilitySettingsSettingsRuleAndDataPullCategoriesEnum;
    /**
     * 
     * @type {number}
     * @memberof FacilitySettingsSettings
     */
    screener_criteria_count_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof FacilitySettingsSettings
     */
    screener_medication_rules_count_limit?: number;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    hospital_chat_notifications?: FacilitySettingsSettingsHospitalChatNotificationsEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    override_ai_analysis_result?: FacilitySettingsSettingsOverrideAiAnalysisResultEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    bed_board?: FacilitySettingsSettingsBedBoardEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    repair_pdf_documents?: FacilitySettingsSettingsRepairPdfDocumentsEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    bed_hold?: FacilitySettingsSettingsBedHoldEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    show_sms_notifications_checkbox?: FacilitySettingsSettingsShowSmsNotificationsCheckboxEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    no_bed_selection_bedboard?: FacilitySettingsSettingsNoBedSelectionBedboardEnum;
    /**
     * 
     * @type {number}
     * @memberof FacilitySettingsSettings
     */
    expanded_payer_list_ratio?: number;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    billing_screener_enabled?: FacilitySettingsSettingsBillingScreenerEnabledEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    esign_request_creation_enabled?: FacilitySettingsSettingsEsignRequestCreationEnabledEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    screener_view_comments_enabled?: FacilitySettingsSettingsScreenerViewCommentsEnabledEnum;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingsSettings
     */
    display_inn_oon_status?: FacilitySettingsSettingsDisplayInnOonStatusEnum;
}


/**
 * @export
 */
export const FacilitySettingsSettingsInsuranceEligibilityCheckEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsInsuranceEligibilityCheckEnum = typeof FacilitySettingsSettingsInsuranceEligibilityCheckEnum[keyof typeof FacilitySettingsSettingsInsuranceEligibilityCheckEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsPdpmEstimatorEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled',
    EnabledAuto: 'enabled_auto'
} as const;
export type FacilitySettingsSettingsPdpmEstimatorEnum = typeof FacilitySettingsSettingsPdpmEstimatorEnum[keyof typeof FacilitySettingsSettingsPdpmEstimatorEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsPalPreauthEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsPalPreauthEnum = typeof FacilitySettingsSettingsPalPreauthEnum[keyof typeof FacilitySettingsSettingsPalPreauthEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsPalHospitalInitiatedEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsPalHospitalInitiatedEnum = typeof FacilitySettingsSettingsPalHospitalInitiatedEnum[keyof typeof FacilitySettingsSettingsPalHospitalInitiatedEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsTimReportEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsTimReportEnum = typeof FacilitySettingsSettingsTimReportEnum[keyof typeof FacilitySettingsSettingsTimReportEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsPhoneAgentEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled',
    EnabledConference: 'enabled_conference'
} as const;
export type FacilitySettingsSettingsPhoneAgentEnum = typeof FacilitySettingsSettingsPhoneAgentEnum[keyof typeof FacilitySettingsSettingsPhoneAgentEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsWaitlistEnabledEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsWaitlistEnabledEnum = typeof FacilitySettingsSettingsWaitlistEnabledEnum[keyof typeof FacilitySettingsSettingsWaitlistEnabledEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsAutomaticallyAddToWaitlistEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsAutomaticallyAddToWaitlistEnum = typeof FacilitySettingsSettingsAutomaticallyAddToWaitlistEnum[keyof typeof FacilitySettingsSettingsAutomaticallyAddToWaitlistEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsRuleAndDataPullCategoriesEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsRuleAndDataPullCategoriesEnum = typeof FacilitySettingsSettingsRuleAndDataPullCategoriesEnum[keyof typeof FacilitySettingsSettingsRuleAndDataPullCategoriesEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsHospitalChatNotificationsEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsHospitalChatNotificationsEnum = typeof FacilitySettingsSettingsHospitalChatNotificationsEnum[keyof typeof FacilitySettingsSettingsHospitalChatNotificationsEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsOverrideAiAnalysisResultEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsOverrideAiAnalysisResultEnum = typeof FacilitySettingsSettingsOverrideAiAnalysisResultEnum[keyof typeof FacilitySettingsSettingsOverrideAiAnalysisResultEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsBedBoardEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsBedBoardEnum = typeof FacilitySettingsSettingsBedBoardEnum[keyof typeof FacilitySettingsSettingsBedBoardEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsRepairPdfDocumentsEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsRepairPdfDocumentsEnum = typeof FacilitySettingsSettingsRepairPdfDocumentsEnum[keyof typeof FacilitySettingsSettingsRepairPdfDocumentsEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsBedHoldEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsBedHoldEnum = typeof FacilitySettingsSettingsBedHoldEnum[keyof typeof FacilitySettingsSettingsBedHoldEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsShowSmsNotificationsCheckboxEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsShowSmsNotificationsCheckboxEnum = typeof FacilitySettingsSettingsShowSmsNotificationsCheckboxEnum[keyof typeof FacilitySettingsSettingsShowSmsNotificationsCheckboxEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsNoBedSelectionBedboardEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsNoBedSelectionBedboardEnum = typeof FacilitySettingsSettingsNoBedSelectionBedboardEnum[keyof typeof FacilitySettingsSettingsNoBedSelectionBedboardEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsBillingScreenerEnabledEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsBillingScreenerEnabledEnum = typeof FacilitySettingsSettingsBillingScreenerEnabledEnum[keyof typeof FacilitySettingsSettingsBillingScreenerEnabledEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsEsignRequestCreationEnabledEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsEsignRequestCreationEnabledEnum = typeof FacilitySettingsSettingsEsignRequestCreationEnabledEnum[keyof typeof FacilitySettingsSettingsEsignRequestCreationEnabledEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsScreenerViewCommentsEnabledEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsScreenerViewCommentsEnabledEnum = typeof FacilitySettingsSettingsScreenerViewCommentsEnabledEnum[keyof typeof FacilitySettingsSettingsScreenerViewCommentsEnabledEnum];

/**
 * @export
 */
export const FacilitySettingsSettingsDisplayInnOonStatusEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type FacilitySettingsSettingsDisplayInnOonStatusEnum = typeof FacilitySettingsSettingsDisplayInnOonStatusEnum[keyof typeof FacilitySettingsSettingsDisplayInnOonStatusEnum];


/**
 * Check if a given object implements the FacilitySettingsSettings interface.
 */
export function instanceOfFacilitySettingsSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "insurance_eligibility_check" in value;
    isInstance = isInstance && "pdpm_estimator" in value;

    return isInstance;
}

export function FacilitySettingsSettingsFromJSON(json: any): FacilitySettingsSettings {
    return FacilitySettingsSettingsFromJSONTyped(json, false);
}

export function FacilitySettingsSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilitySettingsSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'insurance_eligibility_check': json['insurance_eligibility_check'],
        'pdpm_estimator': json['pdpm_estimator'],
        'pal_preauth': !exists(json, 'pal_preauth') ? undefined : json['pal_preauth'],
        'pal_hospital_initiated': !exists(json, 'pal_hospital_initiated') ? undefined : json['pal_hospital_initiated'],
        'tim_report': !exists(json, 'tim_report') ? undefined : json['tim_report'],
        'phone_agent': !exists(json, 'phone_agent') ? undefined : json['phone_agent'],
        'waitlist_enabled': !exists(json, 'waitlist_enabled') ? undefined : json['waitlist_enabled'],
        'automatically_add_to_waitlist': !exists(json, 'automatically_add_to_waitlist') ? undefined : json['automatically_add_to_waitlist'],
        'rule_and_data_pull_categories': !exists(json, 'rule_and_data_pull_categories') ? undefined : json['rule_and_data_pull_categories'],
        'screener_criteria_count_limit': !exists(json, 'screener_criteria_count_limit') ? undefined : json['screener_criteria_count_limit'],
        'screener_medication_rules_count_limit': !exists(json, 'screener_medication_rules_count_limit') ? undefined : json['screener_medication_rules_count_limit'],
        'hospital_chat_notifications': !exists(json, 'hospital_chat_notifications') ? undefined : json['hospital_chat_notifications'],
        'override_ai_analysis_result': !exists(json, 'override_ai_analysis_result') ? undefined : json['override_ai_analysis_result'],
        'bed_board': !exists(json, 'bed_board') ? undefined : json['bed_board'],
        'repair_pdf_documents': !exists(json, 'repair_pdf_documents') ? undefined : json['repair_pdf_documents'],
        'bed_hold': !exists(json, 'bed_hold') ? undefined : json['bed_hold'],
        'show_sms_notifications_checkbox': !exists(json, 'show_sms_notifications_checkbox') ? undefined : json['show_sms_notifications_checkbox'],
        'no_bed_selection_bedboard': !exists(json, 'no_bed_selection_bedboard') ? undefined : json['no_bed_selection_bedboard'],
        'expanded_payer_list_ratio': !exists(json, 'expanded_payer_list_ratio') ? undefined : json['expanded_payer_list_ratio'],
        'billing_screener_enabled': !exists(json, 'billing_screener_enabled') ? undefined : json['billing_screener_enabled'],
        'esign_request_creation_enabled': !exists(json, 'esign_request_creation_enabled') ? undefined : json['esign_request_creation_enabled'],
        'screener_view_comments_enabled': !exists(json, 'screener_view_comments_enabled') ? undefined : json['screener_view_comments_enabled'],
        'display_inn_oon_status': !exists(json, 'display_inn_oon_status') ? undefined : json['display_inn_oon_status'],
    };
}

export function FacilitySettingsSettingsToJSON(value?: FacilitySettingsSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'insurance_eligibility_check': value.insurance_eligibility_check,
        'pdpm_estimator': value.pdpm_estimator,
        'pal_preauth': value.pal_preauth,
        'pal_hospital_initiated': value.pal_hospital_initiated,
        'tim_report': value.tim_report,
        'phone_agent': value.phone_agent,
        'waitlist_enabled': value.waitlist_enabled,
        'automatically_add_to_waitlist': value.automatically_add_to_waitlist,
        'rule_and_data_pull_categories': value.rule_and_data_pull_categories,
        'screener_criteria_count_limit': value.screener_criteria_count_limit,
        'screener_medication_rules_count_limit': value.screener_medication_rules_count_limit,
        'hospital_chat_notifications': value.hospital_chat_notifications,
        'override_ai_analysis_result': value.override_ai_analysis_result,
        'bed_board': value.bed_board,
        'repair_pdf_documents': value.repair_pdf_documents,
        'bed_hold': value.bed_hold,
        'show_sms_notifications_checkbox': value.show_sms_notifications_checkbox,
        'no_bed_selection_bedboard': value.no_bed_selection_bedboard,
        'expanded_payer_list_ratio': value.expanded_payer_list_ratio,
        'billing_screener_enabled': value.billing_screener_enabled,
        'esign_request_creation_enabled': value.esign_request_creation_enabled,
        'screener_view_comments_enabled': value.screener_view_comments_enabled,
        'display_inn_oon_status': value.display_inn_oon_status,
    };
}

